import * as React from 'react';

import { ConfirmationDialogSettings } from './components/ConfirmationDialog/component';

export type ConfirmDialogCallback = (
  description: string | React.ReactNode,
  handler: (confirm: boolean) => void,
) => void;

export type UseDialogsProviderOutput = {
  setConfirmationDialogSettingsRef: React.MutableRefObject<
    ((current: ConfirmationDialogSettings) => void) | undefined
  >;
  confirm: ConfirmDialogCallback;
};

export const useDialogsProvider = (): UseDialogsProviderOutput => {
  const setConfirmationDialogSettingsRef =
    React.useRef<(current: ConfirmationDialogSettings) => void>();

  const confirm = React.useCallback(
    (
      description: string | React.ReactNode,
      handler: (confirmed: boolean) => void,
    ) => {
      if (setConfirmationDialogSettingsRef.current) {
        setConfirmationDialogSettingsRef.current({
          description,
          handler,
        });
      }
    },
    [setConfirmationDialogSettingsRef],
  );

  return {
    setConfirmationDialogSettingsRef,
    confirm,
  };
};
